import { useAppSelector } from '@user/store/hooks'
import { FEATURES } from '@sales-center/common/tenantFeatures'
import { selectTenantFeatureById } from '@user/store/tenantFeatures'

export function useAutoReviewPendingLeadsEnabled() {
  const feature = useAppSelector((state) =>
    selectTenantFeatureById(state, FEATURES.AutoReviewPendingLeads),
  )

  return feature?.enabled ?? false
}
